






















































import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';
import PrettyCheck from 'pretty-checkbox-vue/check';

import useEcho from '@/useEcho';

import {
  getUsersWithQuestion,
  deleteQuestionAnswers,
  getQAAsCSV,
  getAllQAAsCSV,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PageColumnWithVisitorList = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { route, routerPersist, router } = useRouter(['searchString', 'searchStatus']);
    const { pusher } = useEcho();

    const loading = ref(true);
    const visitors = ref([]);
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
    });
    const page = ref(1);
    const sort = ref({ field: 'active', order: 'ASC' });

    const from = ref('');
    const to = ref('');
    const searchString = ref('');

    const callGetVisitors = async () => {
      loading.value = true;
      const data = await getUsersWithQuestion(
        page.value,
        30,
        sort.value,
      );
      visitors.value = data.users.map((user: any) => ({ ...user, newCome: false }));
      // pagination.value = paginatorData;
      loading.value = false;
    };

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetVisitors();
    }, 500);

    async function downloadReport(userId: number) {
      await getQAAsCSV(userId, route.value.params.liveId);
    }

    const deleteItemsModal = ref(null);
    const pendingDeleteItemId = ref(-1);
    const deleteQuestions = async (userId: number) => {
      pendingDeleteItemId.value = userId;
      (deleteItemsModal.value as any).compose({ entity: 'ลบแชททั้งหมด' });
    };
    async function deleteItemsAction() {
      await deleteQuestionAnswers(pendingDeleteItemId.value, route.value.params.liveId);
      await callGetVisitors();
      pendingDeleteItemId.value = -1;
    }

    async function processReceiveChatNotification(data: any) {
      // eslint-disable-next-line
      const matchIndex = visitors.value.findIndex((visitor: any) => visitor.id == data.user.id);
      if (matchIndex > -1) {
        const newestVisitor = visitors.value[matchIndex];
        visitors.value.splice(matchIndex, 1);
        // eslint-disable-next-line
        visitors.value.splice(0, 0, { ...newestVisitor as any, newCome: route.value.params.userId != data.user.id } as never);
      } else {
        visitors.value.splice(0, 0, { ...data.user, newCome: true } as never);
      }
    }

    onMounted(async () => {
      await callGetVisitors();

      if (pusher) {
        const channel = pusher.subscribe('private-admin-questions');
        channel.bind('UserSubmittedQuestion', async (data: any) => { // { user: {}, question: {} };
          await processReceiveChatNotification(data);
        });
      }
    });

    onUnmounted(() => {
      pusher.unsubscribe('private-admin-questions');
    });

    return {
      visitors,
      pagination,

      downloadReport,

      deleteQuestions,
      deleteItemsModal,
      deleteItemsAction,

      getAllQAAsCSV,
    };
  },
});

export default PageColumnWithVisitorList;
